import {StoreProvider} from '@lib/store/StoreProvider';
import {
  currentPageUrlSaved,
  mediaQueryScreenModeSaved,
  orientationSaved,
  pageIndicatorStatusSaved,
} from '@lib/store/appState';
import {
  IApplicationState,
  MediaQueryScreenMode,
  Orientation,
} from '@services/types';

export const createApplicationState = (): IApplicationState => {
  const store = StoreProvider.create();
  return {
    updateCurrentPageUrl: async (url: string) => {
      store.dispatch(currentPageUrlSaved(url));
    },
    updateMediaQueryScreenMode: (mode: MediaQueryScreenMode) => {
      store.dispatch(mediaQueryScreenModeSaved(mode));
    },
    updateOrientation(orientation: Orientation) {
      store.dispatch(orientationSaved(orientation));
    },
    updatePageIndicatorStatus(status) {
      store.dispatch(pageIndicatorStatusSaved(status));
    },
  };
};
